(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn()} else {document.addEventListener('DOMContentLoaded',fn)} }
  function money(cents){ return '$' + (cents/100).toFixed(2); }

  ready(function(){
    document.body.classList.add('agb-body');

    /* offer selection */
    var offers = document.querySelectorAll('.offer');
    function refresh(){
      var sel = document.querySelector('.offer input:checked');
      if(!sel) return;
      var card = sel.closest('.offer');
      offers.forEach(function(c){c.classList.remove('sel')});
      card.classList.add('sel');
      var p = card.getAttribute('data-price'), w = card.getAttribute('data-compare'), s = card.getAttribute('data-save');
      var pn = document.getElementById('priceNow'), pw = document.getElementById('priceWas'), ps = document.getElementById('priceSave'), sp = document.getElementById('stickyPrice');
      if(pn) pn.textContent = p;
      if(pw){ pw.textContent = w || ''; pw.style.display = w ? '' : 'none'; }
      if(ps){ if(s){ ps.textContent = 'Save ' + s; ps.style.display=''; } else { ps.style.display='none'; } }
      if(sp) sp.innerHTML = p + (w ? ' <s>' + w + '</s>' : '');
    }
    offers.forEach(function(c){
      var r = c.querySelector('input[type=radio]');
      if(r) r.addEventListener('change', refresh);
    });
    refresh();

    /* ship date: today + 2 days, skip Sunday */
    var sd = document.getElementById('shipDate');
    if(sd){
      var d = new Date(); d.setDate(d.getDate()+2);
      if(d.getDay()===0) d.setDate(d.getDate()+1);
      sd.textContent = d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric'});
    }

    /* gallery */
    var track = document.getElementById('gtrack');
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('#thumbs button'));
    if(track){
      thumbs.forEach(function(b,i){
        b.addEventListener('click',function(){ track.scrollTo({left: track.clientWidth*i, behavior:'smooth'}); });
      });
      track.addEventListener('scroll',function(){
        var i = Math.round(track.scrollLeft / track.clientWidth);
        thumbs.forEach(function(b,j){b.classList.toggle('on', j===i)});
      },{passive:true});
    }

    /* sticky bar */
    var sticky = document.getElementById('sticky');
    var atcEl = document.getElementById('atcBtn');
    if(sticky && atcEl){
      window.addEventListener('scroll',function(){
        sticky.classList.toggle('show', atcEl.getBoundingClientRect().bottom < 0);
      },{passive:true});
    }

    /* guarantee seal burst */
    var burst = document.getElementById('agb-burst');
    if(burst){
      var pts=[], n=56, cx=110, cy=110, r1=104, r2=93;
      for(var i=0;i<n*2;i++){
        var r = (i%2===0)? r1 : r2;
        var a = Math.PI*i/n;
        pts.push((cx + r*Math.cos(a)).toFixed(1) + ',' + (cy + r*Math.sin(a)).toFixed(1));
      }
      burst.setAttribute('points', pts.join(' '));
    }

    /* ================= CART ================= */
    var shrineDrawer = document.querySelector('cart-drawer');
    var customDrawer = null, backdrop = null, itemsEl = null, totalEl = null;

    function buildCustomDrawer(){
      if(customDrawer) return;
      var wrap = document.createElement('div');
      wrap.innerHTML =
        '<div class="agb-drawer-backdrop" id="agbBackdrop"></div>' +
        '<aside class="agb-drawer" id="agbDrawer" aria-hidden="true">' +
          '<div class="agb-drawer-head"><b>Your Cart</b><button type="button" id="agbDrawerClose" aria-label="Close">✕</button></div>' +
          '<div class="agb-drawer-items" id="agbDrawerItems"></div>' +
          '<div class="agb-drawer-foot">' +
            '<div class="agb-drawer-sub"><span>Subtotal</span><b id="agbDrawerTotal">$0.00</b></div>' +
            '<a class="btn agb-drawer-checkout" href="/checkout">Checkout</a>' +
            '<div class="agb-drawer-note">🔒 Secure checkout &nbsp;•&nbsp; 60-day money-back guarantee</div>' +
          '</div>' +
        '</aside>';
      document.body.appendChild(wrap);
      customDrawer = document.getElementById('agbDrawer');
      backdrop = document.getElementById('agbBackdrop');
      itemsEl = document.getElementById('agbDrawerItems');
      totalEl = document.getElementById('agbDrawerTotal');
      backdrop.addEventListener('click', closeCustom);
      document.getElementById('agbDrawerClose').addEventListener('click', closeCustom);
    }
    function openCustom(){ buildCustomDrawer(); customDrawer.classList.add('open'); backdrop.classList.add('open'); document.body.style.overflow='hidden'; }
    function closeCustom(){ if(!customDrawer) return; customDrawer.classList.remove('open'); backdrop.classList.remove('open'); document.body.style.overflow=''; }

    function renderCart(cart){
      buildCustomDrawer();
      if(!cart.items.length){
        itemsEl.innerHTML = '<div class="agb-drawer-empty">Your cart is empty.</div>';
        totalEl.textContent = money(0);
        return;
      }
      var assetBase = (function(){
        var s = document.querySelector('script[src*="agb-lander"]');
        return s ? s.src.split('agb-lander')[0] : '';
      })();
      function imgUrl(it){
        if(it.image) return it.image;
        if(!assetBase) return '';
        var px = ((it.handle||'') + (it.product_title||'')).toLowerCase().indexOf('garlic') > -1 ? 'agb' : 'vfb';
        return assetBase + px + '-packshot-clean.jpg';
      }
      var html = '';
      cart.items.forEach(function(it){
        var src = imgUrl(it);
        var img = src ? '<img src="' + src + '" alt="">' : '<span>' + (it.product_title||'?').charAt(0) + '</span>';
        var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
        var plan = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan ? it.selling_plan_allocation.selling_plan.name : '';
        var bundle = (it.variant_title||'').match(/Buy\s*(\d+)\s*Get\s*(\d+)\s*Free/i);
        var rows = '';
        if(bundle){
          var paid = parseInt(bundle[1],10), free = parseInt(bundle[2],10);
          var per = it.final_line_price / paid;
          for(var i = 1; i <= paid + free; i++){
            var isFree = i > paid;
            rows += '<div class="agb-di-bottle' + (isFree ? ' free' : '') + '">' +
              (src ? '<img src="' + src + '" alt="">' : '') +
              '<span>Bottle ' + i + (it.quantity > 1 ? ' <em>×' + it.quantity + '</em>' : '') + '</span>' +
              '<b>' + (isFree ? 'FREE' : money(per)) + '</b>' +
            '</div>';
          }
        }
        html += '<div class="agb-drawer-item" data-key="' + it.key + '">' +
          '<div class="agb-di-main">' +
            '<div class="agb-di-img">' + img + '</div>' +
            '<div class="agb-di-mid">' +
              '<b>' + it.product_title + '</b>' +
              (variant ? '<span>' + variant + '</span>' : '') +
              (plan ? '<span class="agb-di-plan">↻ ' + plan + '</span>' : '') +
            '</div>' +
            '<div class="agb-di-price">' + money(it.final_line_price) + '</div>' +
          '</div>' +
          rows +
          '<div class="agb-di-qty">' +
            '<button type="button" class="agb-qty-btn" data-d="-1">−</button>' +
            '<i>' + it.quantity + '</i>' +
            '<button type="button" class="agb-qty-btn" data-d="1">+</button>' +
            '<button type="button" class="agb-di-remove">Remove</button>' +
          '</div>' +
        '</div>';
      });
      itemsEl.innerHTML = html;
      totalEl.textContent = money(cart.items_subtotal_price);
      itemsEl.querySelectorAll('.agb-drawer-item').forEach(function(row){
        var key = row.getAttribute('data-key');
        var qty = parseInt(row.querySelector('.agb-di-qty i').textContent, 10);
        row.querySelectorAll('.agb-qty-btn').forEach(function(b){
          b.addEventListener('click', function(){ changeQty(key, qty + parseInt(b.getAttribute('data-d'),10)); });
        });
        row.querySelector('.agb-di-remove').addEventListener('click', function(){ changeQty(key, 0); });
      });
    }
    function refreshCartUI(){ return fetch('/cart.js').then(function(r){return r.json()}).then(renderCart); }
    function changeQty(key, q){
      fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ id:key, quantity: Math.max(0,q) }) })
        .then(function(r){return r.json()}).then(renderCart);
    }

    /* open Shrine's native cart drawer: fetch the canonical section HTML,
       swap the whole element so its own scripts rebind, then open it */
    function openShrine(){
      return fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function(r){ return r.json(); })
        .then(function(s){
          var html = s['cart-drawer'];
          if(!html) throw new Error('no section');
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('cart-drawer');
          var d = document.querySelector('cart-drawer');
          if(!d) throw new Error('no drawer');
          if(fresh){ d.innerHTML = fresh.innerHTML; }
          var inner = d.querySelector('.drawer__inner');
          if(inner) inner.classList.remove('is-empty');
          d.classList.remove('is-empty');
          return new Promise(function(res){
            setTimeout(function(){
              try{ if(typeof d.open === 'function'){ d.open(); } }catch(e){}
              d.classList.add('animate','active');
              document.body.classList.add('overflow-hidden');
              res(true);
            }, 60);
          });
        });
    }

    function addToCart(){
      var sel = document.querySelector('.offer input:checked');
      if(!sel){ window.location.href = '/cart'; return; }
      /* clean payload — never read the form wholesale; third-party apps
         (e.g. Kaching) inject hidden fields that hijack the line */
      var item = { id: parseInt(sel.value, 10), quantity: 1 };
      var toggle = document.getElementById('refillsToggle');
      var plan = sel.getAttribute('data-plan');
      if(toggle && toggle.checked && plan){ item.selling_plan = parseInt(plan, 10); }

      return fetch('/cart/add.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({ items: [item] })
        })
        .then(function(r){ if(!r.ok){ throw new Error('add failed'); } return r.json(); })
        .then(function(){ return refreshCartUI().then(openCustom); })
        .catch(function(){ window.location.href='/cart'; });
    }

    var form = document.getElementById('agb-product-form');
    if(form){
      form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });
    }
    document.querySelectorAll('a.btn[href="#offer"]').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); addToCart(); });
    });
  });
})();
